const missingTableErrors = [
  'Requested resource not found',
  'ResourceNotFoundException',
];
const encryptionKeyErrors = [
  'INTEGRATIONS_ENCRYPTION_KEY',
  'Unable to decrypt integration credentials',
];
const sendgridEditorErrors = [
  'cannot switch editors',
  'You cannot switch editors once a dynamic template version has been created',
];

export const getIntegrationErrorMessage = (message?: string) => {
  if (missingTableErrors.some((error) => message?.includes(error))) {
    return 'Integrations are not configured in this environment. Create the HTMLEMAIL_Integrations DynamoDB table, then reload.';
  }

  if (encryptionKeyErrors.some((error) => message?.includes(error))) {
    return 'Integration credentials are unavailable. Contact support.';
  }

  if (
    sendgridEditorErrors.some((error) =>
      message?.toLowerCase().includes(error.toLowerCase())
    )
  ) {
    return 'SendGrid won’t update this template because its editor type is locked. Postdrop syncs with SendGrid’s Code Editor—if this version was opened or saved in the Design Editor, create a new Code Editor version in SendGrid, make it active, then sync again.';
  }

  return message || 'Unable to load integrations.';
};
